export default __webpack_public_path__ + "static/media/inbox_slash.a8e613c9.svg";